import React from "react";
import { Alert, Box, Container, Typography, Divider } from "@mui/material";

/**
 * Draft CareVerify facility ToS page (PROMPT 6).
 * Pending legal review — not finalized Terms language.
 * Route: /careverify-terms-draft
 */
const CareVerifyTermsDraftPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Alert severity="warning" sx={{ mb: 3 }}>
        Pending legal review — this is draft product language only and is not
        finalized Terms of Service.
      </Alert>

      <Typography variant="h4" component="h1" gutterBottom>
        CareVerify facility terms (draft)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        For counsel and product review. Do not treat this page as binding ToS.
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box component="section" sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          CareVerify Manager
        </Typography>
        <Typography variant="body1" paragraph>
          The facility designates one or more CareVerify Managers (which may
          include an external billing or RCM vendor account manager) responsible
          for maintaining the billing-entity roster, reporting network
          participation at the product-line level for each payer, and keeping
          attestation current on a 90-day re-attestation cadence.
        </Typography>
        <Typography variant="body1" paragraph>
          Payer-name-only reporting is not accepted. Separately-billing
          professional groups must be identified when they bill independently of
          the facility.
        </Typography>
      </Box>

      <Box component="section" sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Reliance and misdirection
        </Typography>
        <Typography variant="body1" paragraph>
          Patients and facilities may rely on attestation for coverage-confidence
          display, subject to platform disclaimers. Confirmed coverage-misdirection
          reports may affect facility standing on CareVerify after triage and a
          cure period.
        </Typography>
      </Box>

      <Box component="section">
        <Typography variant="h6" gutterBottom>
          Disclaimer (draft)
        </Typography>
        <Typography variant="body1" paragraph>
          CareVerify coverage-confidence results are informational. They do not
          constitute a guarantee of payment, authorization, referral approval, or
          medical necessity determination.
        </Typography>
      </Box>
    </Container>
  );
};

export default CareVerifyTermsDraftPage;
